import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  useState,
  useEffect,
  type Dispatch,
  type SetStateAction
} from "react";
import { HeaderDesktop } from "./children/HeaderDesktop.component";
import { HeaderMobile } from "./children/HeaderMobile.component";
import { DROPDOWN, type Dropdown } from "./Header.consts";
import type { Language } from "../../types";

type HeaderProps = {
  authenticated?: boolean
  showTutorialUserMenu?: boolean
  isMultilanguage?: boolean
  languages?: Language[]
  isPreLogin?: boolean
}

export function Header({
  authenticated=false,
  showTutorialUserMenu,
  isMultilanguage,
  languages,
  isPreLogin
}: HeaderProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  /* move to store/context */
  const [anchorElDropdown, setAnchorElDropdown] = useState<HTMLElement | null>(null);
  const [anchorElNotify, setAnchorElNotify] = useState<HTMLElement | null>(null);
  const [dropdown, setDropdown] = useState<Dropdown | null>(null);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false); // TODO: can this become local?
  const [searchValue, setSearchValue] = useState("");
  /* move to store/context */

  const [languageModalOpen, setLanguageModalOpen] = useState(false);
  const [impersonationModalOpen, setImpersonationModalOpen] = useState(false);

  useWrapper({
    hideDropdowns: () => { setDropdown(null) },
    setSearchValue,
    showSearchResults: dropdown === DROPDOWN.SEARCH
  });

  useEffect(() => {
    if (showTutorialUserMenu) {
      setDropdown(DROPDOWN.MENU);
    } else {
      setDropdown(null);
    }

  }, [showTutorialUserMenu]);

  useEffect(() => {
    if(!isMobile && mobileSearchOpen) setMobileSearchOpen(false);
  }, [isMobile, mobileSearchOpen]);

  return !isMobile ? (
    <HeaderDesktop
      authenticated={ authenticated }
      isMultilanguage={ isMultilanguage }
      languages={ languages }
      isPreLogin={ isPreLogin }
      dropdown={ dropdown }
      setDropdown={ setDropdown }
      anchorElDropdown={ anchorElDropdown }
      setAnchorElDropdown={ setAnchorElDropdown }
      anchorElNotify={ anchorElNotify }
      setAnchorElNotify={ setAnchorElNotify }
      mobileSearchOpen={ mobileSearchOpen }
      searchValue={ searchValue }
      setSearchValue={ setSearchValue }
      languageModalOpen={ languageModalOpen }
      setLanguageModalOpen={ setLanguageModalOpen }
      impersonationModalOpen={ impersonationModalOpen }
      setImpersonationModalOpen={ setImpersonationModalOpen }
    />
  ) : (
    <HeaderMobile
      authenticated={ authenticated }
      showTutorialUserMenu={ showTutorialUserMenu }
      isMultilanguage={ isMultilanguage }
      languages={ languages }
      isPreLogin={ isPreLogin }
      dropdown={ dropdown }
      setDropdown={ setDropdown }
      anchorElDropdown={ anchorElDropdown }
      setAnchorElDropdown={ setAnchorElDropdown }
      mobileSearchOpen={ mobileSearchOpen }
      setMobileSearchOpen={ setMobileSearchOpen }
      searchValue={ searchValue }
      setSearchValue={ setSearchValue }
      languageModalOpen={ languageModalOpen }
      setLanguageModalOpen={ setLanguageModalOpen }
      impersonationModalOpen={ impersonationModalOpen }
      setImpersonationModalOpen={ setImpersonationModalOpen }
    />
  );
}

// TODO: farmi spiegare da Robi wtf, needed on mobile? setShowSearchResults?
function useWrapper({
  hideDropdowns,
  setSearchValue,
  showSearchResults
} : {
  hideDropdowns: () => void
  setSearchValue: Dispatch<SetStateAction<string>>
  showSearchResults: boolean
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const wrapper = document.querySelector("#root .mask");
  wrapper?.addEventListener("click", () => {
    if (showSearchResults) {
      wrapper?.classList.remove("has-mask");
      hideDropdowns();
    }
  });

  useEffect(() => {
    if (showSearchResults) {
      if(isMobile){
        wrapper?.classList.remove("has-mask");
      }else{
        wrapper?.classList.add("has-mask");
      }
    } else {
      setSearchValue("");
      wrapper?.classList.remove("has-mask");
    }
  }, [wrapper, showSearchResults, setSearchValue, isMobile]);
}
